/**
 * @fileoverview gRPC-Web generated client stub for request
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: request/request.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var common_collections_pb = require('../common/collections_pb.js')

var attachment_attachment_pb = require('../attachment/attachment_pb.js')
const proto = {};
proto.request = require('./request_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.request.RequestClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.request.RequestPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.CreateOrUpdateDocumentRequestRequest,
 *   !proto.request.DocumentRequest>}
 */
const methodDescriptor_Request_CreateOrUpdateDocumentRequest = new grpc.web.MethodDescriptor(
  '/request.Request/CreateOrUpdateDocumentRequest',
  grpc.web.MethodType.UNARY,
  proto.request.CreateOrUpdateDocumentRequestRequest,
  proto.request.DocumentRequest,
  /**
   * @param {!proto.request.CreateOrUpdateDocumentRequestRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.DocumentRequest.deserializeBinary
);


/**
 * @param {!proto.request.CreateOrUpdateDocumentRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.DocumentRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.DocumentRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.createOrUpdateDocumentRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/CreateOrUpdateDocumentRequest',
      request,
      metadata || {},
      methodDescriptor_Request_CreateOrUpdateDocumentRequest,
      callback);
};


/**
 * @param {!proto.request.CreateOrUpdateDocumentRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.DocumentRequest>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.createOrUpdateDocumentRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/CreateOrUpdateDocumentRequest',
      request,
      metadata || {},
      methodDescriptor_Request_CreateOrUpdateDocumentRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.DocumentRequest,
 *   !proto.request.DocumentRequest>}
 */
const methodDescriptor_Request_CreateDocumentRequest = new grpc.web.MethodDescriptor(
  '/request.Request/CreateDocumentRequest',
  grpc.web.MethodType.UNARY,
  proto.request.DocumentRequest,
  proto.request.DocumentRequest,
  /**
   * @param {!proto.request.DocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.DocumentRequest.deserializeBinary
);


/**
 * @param {!proto.request.DocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.DocumentRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.DocumentRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.createDocumentRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/CreateDocumentRequest',
      request,
      metadata || {},
      methodDescriptor_Request_CreateDocumentRequest,
      callback);
};


/**
 * @param {!proto.request.DocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.DocumentRequest>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.createDocumentRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/CreateDocumentRequest',
      request,
      metadata || {},
      methodDescriptor_Request_CreateDocumentRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.UpdateDocumentRequestRequest,
 *   !proto.request.DocumentRequest>}
 */
const methodDescriptor_Request_UpdateDocumentRequest = new grpc.web.MethodDescriptor(
  '/request.Request/UpdateDocumentRequest',
  grpc.web.MethodType.UNARY,
  proto.request.UpdateDocumentRequestRequest,
  proto.request.DocumentRequest,
  /**
   * @param {!proto.request.UpdateDocumentRequestRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.DocumentRequest.deserializeBinary
);


/**
 * @param {!proto.request.UpdateDocumentRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.DocumentRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.DocumentRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.updateDocumentRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/UpdateDocumentRequest',
      request,
      metadata || {},
      methodDescriptor_Request_UpdateDocumentRequest,
      callback);
};


/**
 * @param {!proto.request.UpdateDocumentRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.DocumentRequest>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.updateDocumentRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/UpdateDocumentRequest',
      request,
      metadata || {},
      methodDescriptor_Request_UpdateDocumentRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.ListDocumentRequestsRequest,
 *   !proto.request.DocumentRequests>}
 */
const methodDescriptor_Request_ListDocumentRequests = new grpc.web.MethodDescriptor(
  '/request.Request/ListDocumentRequests',
  grpc.web.MethodType.UNARY,
  proto.request.ListDocumentRequestsRequest,
  proto.request.DocumentRequests,
  /**
   * @param {!proto.request.ListDocumentRequestsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.DocumentRequests.deserializeBinary
);


/**
 * @param {!proto.request.ListDocumentRequestsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.DocumentRequests)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.DocumentRequests>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.listDocumentRequests =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/ListDocumentRequests',
      request,
      metadata || {},
      methodDescriptor_Request_ListDocumentRequests,
      callback);
};


/**
 * @param {!proto.request.ListDocumentRequestsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.DocumentRequests>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.listDocumentRequests =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/ListDocumentRequests',
      request,
      metadata || {},
      methodDescriptor_Request_ListDocumentRequests);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.DeleteDocumentRequestRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Request_DeleteDocumentRequest = new grpc.web.MethodDescriptor(
  '/request.Request/DeleteDocumentRequest',
  grpc.web.MethodType.UNARY,
  proto.request.DeleteDocumentRequestRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.request.DeleteDocumentRequestRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.request.DeleteDocumentRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.deleteDocumentRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/DeleteDocumentRequest',
      request,
      metadata || {},
      methodDescriptor_Request_DeleteDocumentRequest,
      callback);
};


/**
 * @param {!proto.request.DeleteDocumentRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.deleteDocumentRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/DeleteDocumentRequest',
      request,
      metadata || {},
      methodDescriptor_Request_DeleteDocumentRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.ListDocumentRequestsRequest,
 *   !proto.request.CountDocumentRequestsResponse>}
 */
const methodDescriptor_Request_CountDocumentRequests = new grpc.web.MethodDescriptor(
  '/request.Request/CountDocumentRequests',
  grpc.web.MethodType.UNARY,
  proto.request.ListDocumentRequestsRequest,
  proto.request.CountDocumentRequestsResponse,
  /**
   * @param {!proto.request.ListDocumentRequestsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.CountDocumentRequestsResponse.deserializeBinary
);


/**
 * @param {!proto.request.ListDocumentRequestsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.CountDocumentRequestsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.CountDocumentRequestsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.countDocumentRequests =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/CountDocumentRequests',
      request,
      metadata || {},
      methodDescriptor_Request_CountDocumentRequests,
      callback);
};


/**
 * @param {!proto.request.ListDocumentRequestsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.CountDocumentRequestsResponse>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.countDocumentRequests =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/CountDocumentRequests',
      request,
      metadata || {},
      methodDescriptor_Request_CountDocumentRequests);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.LinkControlsToRequestRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Request_LinkControlsToRequest = new grpc.web.MethodDescriptor(
  '/request.Request/LinkControlsToRequest',
  grpc.web.MethodType.UNARY,
  proto.request.LinkControlsToRequestRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.request.LinkControlsToRequestRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.request.LinkControlsToRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.linkControlsToRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/LinkControlsToRequest',
      request,
      metadata || {},
      methodDescriptor_Request_LinkControlsToRequest,
      callback);
};


/**
 * @param {!proto.request.LinkControlsToRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.linkControlsToRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/LinkControlsToRequest',
      request,
      metadata || {},
      methodDescriptor_Request_LinkControlsToRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.LinkRequestsToControlRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Request_LinkRequestsToControl = new grpc.web.MethodDescriptor(
  '/request.Request/LinkRequestsToControl',
  grpc.web.MethodType.UNARY,
  proto.request.LinkRequestsToControlRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.request.LinkRequestsToControlRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.request.LinkRequestsToControlRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.linkRequestsToControl =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/LinkRequestsToControl',
      request,
      metadata || {},
      methodDescriptor_Request_LinkRequestsToControl,
      callback);
};


/**
 * @param {!proto.request.LinkRequestsToControlRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.linkRequestsToControl =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/LinkRequestsToControl',
      request,
      metadata || {},
      methodDescriptor_Request_LinkRequestsToControl);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.UnlinkControlFromRequestRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Request_UnlinkControlFromRequest = new grpc.web.MethodDescriptor(
  '/request.Request/UnlinkControlFromRequest',
  grpc.web.MethodType.UNARY,
  proto.request.UnlinkControlFromRequestRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.request.UnlinkControlFromRequestRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.request.UnlinkControlFromRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.unlinkControlFromRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/UnlinkControlFromRequest',
      request,
      metadata || {},
      methodDescriptor_Request_UnlinkControlFromRequest,
      callback);
};


/**
 * @param {!proto.request.UnlinkControlFromRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.unlinkControlFromRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/UnlinkControlFromRequest',
      request,
      metadata || {},
      methodDescriptor_Request_UnlinkControlFromRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.BulkCreateDocumentRequestsRequest,
 *   !proto.request.DocumentRequests>}
 */
const methodDescriptor_Request_BulkCreateDocumentRequests = new grpc.web.MethodDescriptor(
  '/request.Request/BulkCreateDocumentRequests',
  grpc.web.MethodType.UNARY,
  proto.request.BulkCreateDocumentRequestsRequest,
  proto.request.DocumentRequests,
  /**
   * @param {!proto.request.BulkCreateDocumentRequestsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.DocumentRequests.deserializeBinary
);


/**
 * @param {!proto.request.BulkCreateDocumentRequestsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.DocumentRequests)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.DocumentRequests>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.bulkCreateDocumentRequests =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/BulkCreateDocumentRequests',
      request,
      metadata || {},
      methodDescriptor_Request_BulkCreateDocumentRequests,
      callback);
};


/**
 * @param {!proto.request.BulkCreateDocumentRequestsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.DocumentRequests>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.bulkCreateDocumentRequests =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/BulkCreateDocumentRequests',
      request,
      metadata || {},
      methodDescriptor_Request_BulkCreateDocumentRequests);
};


module.exports = proto.request;

